import { Paragraph } from "types/Paragraph";

export const useParagraphTokensWithoutLinebreaks = (
  paragraph: Paragraph
): ParagraphTokens => {
  return paragraph.tokens.filter((token) => token.text !== "\n");
};
